import $ from 'jquery';
import ko from 'knockout';
import templateMarkup from 'raw-loader!./update-tags-form.html';
import _ from 'lodash';
import '../../../app/bindings/ko-bindinghandler-tokenfield';

        

        function UpdateTagsForm(params) {
            if (!_.has(params, 'signals.onShow') || !_.has(params, 'signals.onSave') || !_.has(params, 'signals.onClose')) {
                throw new Error('UpdateEndpointModal:: Missing required signals: show, save');
            }
            params.enableSave(true);
            params.showSave(true);

            this.signals = params.signals;

            this.tags = ko.observableArray();

            this.model = params.model;

            this.signalListeners = {
                onShow: this.show.bind(this),
                onSave: this.save.bind(this),
                onClose: this.reset.bind(this)
            };

            this.signals.onShow.add(this.signalListeners.onShow);
            this.signals.onSave.add(this.signalListeners.onSave);
            this.signals.onClose.add(this.signalListeners.onClose);
        }

        UpdateTagsForm.prototype.show = function (model) {
            this.model = model;
        };

        UpdateTagsForm.prototype.save = function () {
            var model = ko.unwrap(this.model);
            var tags = ko.unwrap(this.tags);
            model.tags = tags;
            this.signals.onSaveCallback.dispatch(model);
            this.reset();
        };

        UpdateTagsForm.prototype.reset = function () {
            this.tags([]);
        };

        UpdateTagsForm.prototype.dispose = function () {
            this.signals.onShow.remove(this.signalListeners.onShow);
            this.signals.onSave.remove(this.signalListeners.onSave);
            this.signals.onClose.remove(this.signalListeners.onClose);
            delete this.signalListeners;
        };

        export default {
            viewModel: UpdateTagsForm,
            template: templateMarkup
        };
    